import { render, staticRenderFns } from "./detailsActive.vue?vue&type=template&id=945d5388&scoped=true&"
import script from "./detailsActive.vue?vue&type=script&lang=js&"
export * from "./detailsActive.vue?vue&type=script&lang=js&"
import style0 from "./detailsActive.vue?vue&type=style&index=0&id=945d5388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d5388",
  null
  
)

export default component.exports